/**
 * Enregistrement du SW, vérification des mises à jour en ligne, rechargement si nouvelle version.
 */
export function registerServiceWorker( swBuildId, onSync )
{
	if( !('serviceWorker' in navigator ) )
		return;

	var hadController = !!navigator.serviceWorker.controller;
	var reloading   = false;

	navigator.serviceWorker.addEventListener( 'controllerchange', function()
	{
		if( !hadController || reloading )
			return;
		reloading = true;
		window.location.reload();
	} );

	navigator.serviceWorker.addEventListener( 'message', function( evt )
	{
		if( evt.data && evt.data.type === 'SW_SYNC' )
			onSync();
	} );

	function checkForUpdate()
	{
		if( !navigator.onLine )
			return;

		navigator.serviceWorker.ready.then( function( reg )
		{
			reg.update().catch( function() {} );
		} );
	}

	navigator.serviceWorker.register( './service-worker.js?v=' + encodeURIComponent( swBuildId ) )
		.then( function( reg )
		{
			console.log( 'SW registered', reg.scope );
			checkForUpdate();
		} )
		.catch( function( err ) { console.warn( 'SW registration failed', err ); } );

	window.addEventListener( 'online', checkForUpdate );
	document.addEventListener( 'visibilitychange', function()
	{
		if( document.visibilityState === 'visible' )
			checkForUpdate();
	} );
}
